var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('VListSessionPrincipal',{staticClass:"pt-0",attrs:{"principal":_vm.principal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }